jQuery(document).ready(function () {
    function menu_item_mob(){
            jQuery('#primary-menu > li > a, .page_item_has_children > a').off("click touchstart");
            let allItems = jQuery('.menu-item-has-children > a, .page_item_has_children > a').parent();

            jQuery('.menu-item-has-children > a, .page_item_has_children > a').on("click touchstart", function(event){
                allItems.not(jQuery(this).parent('li')).find('.mega-menu').slideUp('fast');
                allItems.not(jQuery(this).parent('li')).removeClass('mobile-sub-opened');

                jQuery(this).parent('li').find('.mega-menu').slideToggle('fast');
                jQuery(this).parent('li').toggleClass('mobile-sub-opened');
                event.stopPropagation();
            });

            jQuery(window).on("click touchstart", function(event){
                let triggeredItems = allItems.has(event.target).toArray();
                if(triggeredItems.length == 0) {
                    allItems.removeClass('mobile-sub-opened');
                    allItems.find('.mega-menu').slideUp('fast');
                }
            });
            jQuery('.nav-wrapper #primary-menu a[href="/#"]').each(function(){
                jQuery(this).removeAttr('href');
            });
    }
    function footer_accordion(){
        if (jQuery(window).width() < 686) {
            jQuery('.footer-menus .menu-block .menu-title').click(function (){
                jQuery(this).toggleClass('active');
                jQuery(this).next().toggleClass('active');
            });
        }
    }
    menu_item_mob();
    window.addEventListener("load", footer_accordion);

    // Link whole tile
	jQuery('body').on('click', '.clickable-item', function (e) {
		e.preventDefault();

		let url = jQuery(this).attr('data-clickable'),
			target = jQuery(this).attr('data-target');
		if (url) {
			if (target == '_blank') {
				window.open(
					url,
					'_blank'
				);
			} else {
				window.location.href = url;
			}
		}

	});

    if (jQuery('#contact-section').length === 0) {
        // If the section doesn't exist, change the link of the button
        jQuery('.contact .btn').attr('href', '/contact-us');
    }
    // Make blog titles equal height

	jQuery('.blog-post-item__content--title').matchHeight();

    jQuery(function() {
        function handleMenuBehavior() {
            var windowWidth = jQuery(window).width();

            if (windowWidth >= 1024) {
                jQuery('.nav_column .menu-item-has-children').off('click').on('click', function(e) {
                    // e.preventDefault();
                    var submenu = jQuery(this).children('.sub-menu');
                    submenu.stop(true, true).slideToggle(200);
                    submenu.toggleClass('dropdown-opened');
                    jQuery(this).toggleClass('focus');
                });
            } else {
                jQuery('.nav_column .menu-item-has-children').off('mouseenter mouseleave');
                jQuery('.nav_column .menu-item-has-children').on('click', function(e) {
                    var submenu = jQuery(this).children('.sub-menu');
                    jQuery('.nav_column .menu-item-has-children').not(this).children('.sub-menu').removeClass('dropdown-opened');
                    jQuery('.nav_column .menu-item-has-children').not(this).removeClass('focus');
                    if (!submenu.is(":visible")) {
                        submenu.stop(true, true).addClass('dropdown-opened');
                        jQuery(this).addClass('focus');
                    } else {
                        submenu.stop(true, true).removeClass('dropdown-opened');
                        jQuery(this).removeClass('focus');
                    }

                    e.stopPropagation();
                });
            }
        }
        handleMenuBehavior();
        jQuery(window).resize(function() {
            //handleMenuBehavior();
        });
    });



    jQuery('.mega-menu .menu-item-has-children>a').each(function () {
        jQuery(this).remove();
    });

    jQuery('.mega-menu>.sub-menu>li>.sub-menu>li>.sub-menu>li>a').each(function() {
        jQuery(this).remove();
    });

    jQuery('.mega-menu>.sub-menu>li>.sub-menu>li>a').each(function() {
        jQuery(this).remove();
    });
});
